import React from 'react';
import { MenuButton } from './topbar/menu-button/MenuButton';
import { BrandLink } from './topbar/brand-link/BrandLink';
import { Sidebar } from './sidebar/Sidebar';
import { NotificationPreviewListTrigger } from '../../../messages-notifications/notifications/preview-list/NotificationPreviewListTrigger';
import { MessagePreviewListTrigger } from '../../../messages-notifications/messages/preview-list/MessagePreviewListTrigger';
import { AuthContext } from '../../routing/AuthContext';
import './MainLayout.css';

export const MainLayout = (
    {
        children,
    }
) => {
    const { currentUser } = React.useContext(AuthContext);
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
    const collapseSidebar = () => setSidebarCollapsed(!sidebarCollapsed);

    return (
        <div className="ps-main-layout">
            <div className="ps-topbar">
                <MenuButton collapseSidebar={collapseSidebar}/>
                <BrandLink/>
                <div className="ps-topbar-space"/>
                {
                    currentUser.isSuperAdmin() ? null : (
                        <React.Fragment>
                            <MessagePreviewListTrigger/>
                            <NotificationPreviewListTrigger/>
                        </React.Fragment>
                    )
                }
            </div>
            <div className="ps-sidebar-board">
                <Sidebar collapsed={sidebarCollapsed}/>
                <div className="ps-board">
                    {children}
                </div>
            </div>
        </div>
    );
};

MainLayout.propTypes = {};

MainLayout.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/MainLayout.jsx